module.exports = __webpack_public_path__ + "img/send-button-disabled.a341ec37.png";